import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addParkingServiceImage } from '../../api/parking-service.ts';
import { AddParkingServiceImageRequest } from '../../api/requests/parking-service-request.ts';

export default function useAddParkingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof addParkingServiceImage>>,
  Error,
  AddParkingServiceImageRequest
> {
  return useMutation({
    mutationFn: addParkingServiceImage,
  });
}
